// function booh() {
//   ["input",
//     "change",
//     "keydown",
//     "keyup"
//   ].forEach(event => {
//    document.addEventListener(event, () => console.log("fired:", event));
//  });
// }

function prependProtocolOnUrlInputs() {
  const urlInputs = document.querySelectorAll("input[type='url']");

  if (urlInputs.length) {
    function prependProtocol() {
      const input = urlInputs[0];
      const partialRegex = /https?/g; // either https or http
      const fullRegex = /https?\:\/\//g; // either https:// or http://
      const prefix = "https://";
      const prependProtocol = input.value.search(partialRegex) === -1 && input.value.search(fullRegex) === -1;

      if (!prependProtocol) return;

      input.value = prefix + input.value.trimStart();
    }

    urlInputs.forEach(input => input.addEventListener("input", prependProtocol));
    urlInputs.forEach(input => input.addEventListener("change", prependProtocol));
  }
}

function initStreamedRequiredFields() {
  const checkboxes = document.querySelectorAll('[data-validates="interests"]');
  const select     = document.getElementById("contact_timeline");
  const submitBtn  = document.getElementById("submit-btn");

  if (!submitBtn) return;

  if (checkboxes.length) {
    const group = document.getElementById("interests-group");
    const error = document.getElementById("interests-error");

    function syncSubmit() {
      const anyChecked = Array.from(checkboxes).some(cb => cb.checked);

      submitBtn.disabled = !anyChecked;

      // toggle error message visibility and aria-invalid on the group
      error.hidden = anyChecked;
      group.setAttribute("aria-invalid", !anyChecked);
    }

    // only show error state after first interaction, not on load
    checkboxes.forEach(cb => cb.addEventListener("change", syncSubmit));
  }

  if (select) {
    const error = document.getElementById("timeline-error");

    function syncSubmit() {
      const blankOption = select.value === "";

      submitBtn.disabled = blankOption;

      // toggle error message visibility and aria-invalid on the group
      error.hidden = !blankOption;
      //select.setAttribute("aria-invalid", blankOption);
    }

    // only show error state after first interaction, not on load
    select.addEventListener("change", syncSubmit);
  }
}

function initRequiredInitialFields() {
  const submitBtn = document.getElementById("submit-btn");
  const email = document.getElementById("contact_email");
  const error = document.getElementById("email-error");

  if (!email || !submitBtn) return;

  function syncSubmit() {
    const blankOption = email.value === "";

    submitBtn.disabled = blankOption;

    // toggle error message visibility and aria-invalid on the group
    error.hidden = !blankOption;
    email.setAttribute("aria-invalid", blankOption);
  }

  // only show error state after first interaction, not on load
  email.addEventListener("change", syncSubmit);
}

// document.addEventListener("turbo:load", booh);
document.addEventListener("turbo:load", initRequiredInitialFields);
document.addEventListener("turbo:before-morph-element", initStreamedRequiredFields);
document.addEventListener("turbo:load", prependProtocolOnUrlInputs);
document.addEventListener("turbo:before-morph-element", prependProtocolOnUrlInputs);
